export default __webpack_public_path__ + "static/media/music-key-green-bg.9eb2fa79.svg";